<template>
  <v-dialog
    :value="value"
    :max-width="420"
    persistent
    :attach="attach"
    content-class="prr-impersonation-blocked"
    @keydown.esc="handleClose"
  >
    <div
      class="prr-impersonation-blocked__card"
      data-testid="impersonation-blocked-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="prr-impersonation-blocked-title"
    >
      <div class="prr-impersonation-blocked__icon" aria-hidden="true">
        <v-icon large color="#D92D20">mdi-shield-alert-outline</v-icon>
      </div>
      <span id="prr-impersonation-blocked-title" class="prr-impersonation-blocked__title">
        No actions allowed
      </span>
      <span class="prr-impersonation-blocked__body">
        No actions are allowed during impersonation.
        <template v-if="actionLabel">"{{ actionLabel }}" has not been performed.</template>
      </span>
      <div class="prr-impersonation-blocked__actions">
        <StandardButton
          size="small"
          type="magenta"
          variant="primary"
          label="Got it"
          @click="handleClose"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";

const props = defineProps({
  value: { type: Boolean, default: false },
  attemptedAction: { type: String, default: "" },
  attach: { type: String, default: undefined },
});

const emit = defineEmits(["input"]);

const ACTION_LABELS = {
  convert: "Convert to Role",
  detach: "Detach",
  attach: "Attach",
  suggest: "IQ Suggest",
  "import-job-description": "Import Job Description",
};

const actionLabel = computed(() => ACTION_LABELS[props.attemptedAction] || props.attemptedAction);

function handleClose() {
  emit("input", false);
}
</script>

<style scoped>
.prr-impersonation-blocked__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 20px 24px rgba(16, 24, 40, 0.12);
  text-align: center;
}
.prr-impersonation-blocked__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fef3f2;
  margin-bottom: 12px;
}
.prr-impersonation-blocked__title {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #101828;
  margin-bottom: 8px;
}
.prr-impersonation-blocked__body {
  font-size: 14px;
  line-height: 20px;
  color: #475467;
  margin-bottom: 20px;
}
.prr-impersonation-blocked__actions {
  display: flex;
  justify-content: center;
}
</style>
